<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="案例标题">
            <a-input v-model="searchForm.title" allowClear placeholder="请输入案例标题" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select
              v-model="searchForm.line_id"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择发布平台"
              style="width: 100%"
            >
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select
              v-model="searchForm.status"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择状态"
              style="width: 100%"
            >
              <a-select-option v-for="item in STATUS" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布时间">
            <VRangePicker v-model="searchForm.publish_at" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <a-row type="flex" justify="space-between">
      <a-button type="primary" @click="addCase"><a-icon type="plus-circle" />添加案例</a-button>
      <div>
        <a-button type="primary" icon="search" style="margin-right:18px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </a-row>

    <!-- 表格 -->
    <a-table
      size="middle"
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :pagination="pagination"
      style="margin-top: 20px"
      @change="handleTableChange"
    >
      <template slot="line_id" slot-scope="text, record">
        <a-tag color="blue">{{ getLineName(record) }}</a-tag>
      </template>
      <template slot="status" slot-scope="text">
        <span :class="`status-${text}`">{{ showName('STATUS', text) }}</span>
      </template>
      <template slot="operator" slot-scope="text, record">
        <!-- v-if="record.status == 0" -->
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()"> 审核<a-icon type="down" /> </a>
          <a-menu slot="overlay" @click="e => handleAudit(e, record)">
            <a-menu-item :key="1">
              通过
            </a-menu-item>
            <a-menu-item :key="2">
              拒绝
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-button size="small" type="link" @click="handleEdit(record)">编辑</a-button>
        <a-button size="small" type="link" @click="handleDel(record)">删除</a-button>
      </template>
    </a-table>

    <!-- 新增、编辑模板 -->
    <a-modal v-model="visible" :title="addEditTitle" @cancel="handleCancel">
      <a-form-model
        ref="addFormRef"
        :model="addForm"
        :rules="addRules"
        labelAlign="left"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="选择平台" prop="line_id">
          <a-select
            v-model="addForm.line_id"
            placeholder="请输入或选择"
            show-search
            allowClear
            :filter-option="filterOption"
            @change="handleChange"
          >
            <a-select-option v-for="item in lineListLv1" :key="item.id" :value="item.id">
              {{ item.org }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 下拉选项为模板管理列表发布平台 = 当前平台，且状态 = 开启 的模板名称 -->
        <a-form-model-item label="模板名称" prop="template_id">
          <a-select
            v-model="addForm.template_id"
            :disabled="!addForm.line_id"
            placeholder="请输入或选择"
            show-search
            allowClear
            :filter-option="filterOption"
          >
            <a-select-option v-for="item in templateList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">取 消</a-button>
        <a-button key="submit" type="primary" :loading="sbtloading" @click="handleOk">下一步</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import { computed, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { VRangePicker } from '@/components/FormElements'
import pagination from '@/composables/pagination'
import compuedFun from '@/views/casesManage/computed/'
import api from '@/api/'
import { casesList, casesUpdateStatus, casesDelete } from '@/api/caseManagement/index'

import { cloneDeep } from 'lodash'
import { parseTime } from '@/utils/util'
const { showName } = compuedFun()

const formReset = {
  title: undefined, // 案例标题
  status: undefined, // 审核状态 0待审核 1审核通过 2审核不通过
  line_id: undefined, // 平台id
  publish_at: [] // 发布时间：start_date、end_date
}
const addFormReset = {
  line_id: undefined,
  template_id: undefined
}

const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'org',
    align: 'left',
    width: 200,
    scopedSlots: { customRender: 'line_id' }
  },
  {
    title: '案例标题',
    dataIndex: 'title',
    align: 'left',
  },
  {
    title: '创建人',
    dataIndex: 'name',
    width: 150,
    align: 'left',
    customRender(text, record) {
      const { add_person, add_person_name } = record
      if (add_person_name) {
        return `${add_person_name} (${add_person})`
      }
      return '--'
    }
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 185,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'operator' }
  }
]

export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      loading: false,
      visible: false,
      addEditTitle: '',
      sbtloading: false,
      templateList: [],
      platformList: [], // 发布平台
      searchForm: cloneDeep(formReset),

      addForm: cloneDeep(addFormReset),
      addRules: {
        line_id: [{ required: true, message: '请选择平台', trigger: 'blur' }],
        template_id: [{ required: true, message: '请选择模板', trigger: 'blur' }]
      }
    })

    const lineListLv1 = computed(() => {
      return state.platformList.filter(item => {
        if (item.parent_id === 0) {
          return item
        }
      })
    })

    onMounted(() => {
      methods.getPlatform()
      methods.getList()
    })
    onUnmounted(async () => {
    })

    const methods = {
      addCase() {
        _this.addEditTitle = '新增案例'
        _this.visible = true
      },
      search() {
        _this.pagination.current = 1
        _this.getList()
      },
      getSearchParams() {
        const queryParams = { ...state.searchForm }
        if (Array.isArray(queryParams.publish_at) && queryParams.publish_at.length === 2) {
          queryParams.start_date = moment.unix(queryParams.publish_at[0]).startOf('day').unix()
          queryParams.end_date = moment.unix(queryParams.publish_at[1]).endOf('day').unix()
        } else {
          delete queryParams.start_date
          delete queryParams.end_date
        }
        delete queryParams.publish_at
        return queryParams
      },
      async getList() {
        _this.loading = true
        const res = await casesList({
          ...methods.getSearchParams(),
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        }).finally(() => {
            _this.loading = false
        })
        // const { list, pagination } = res.data
        // _this.data = list
        // _this.pagination.total = pagination.total
          if (res.code === '000000') {
          _this.data = res?.data?.list
          _this.pagination.total = res?.data?.pagination.total
          }
      },

      // 获取发布平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },
      // 发布平台
      getLineName(record) {
        return state.platformList.find(item => String(item.id) === String(record.line_id))?.org ?? '--'
      },

      // 清除
      handleClear() {
        state.searchForm = cloneDeep(formReset)
        _this.search()
      },

      // 表格操作
      handleAudit({ key }, row) {
        // 审核状态 0待审核 1审核通过 2审核不通过
        // if (Number(row.status) === 0) {
          const _title = key === 1 ? '通过' : '拒绝'
          _this.$confirm({
            title: `确定要${_title}吗？`,
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
              const res = await casesUpdateStatus({
                id: row.id,
                status: key
              })
              if (_this.$validate(res)) {
                _this.$message.success(`操作成功！`)
                methods.getList()
              }
            }
          })
        // }
      },
      handleEdit(row) {
        const { line_id, template_id } = row
        this.$router.push({
          name: 'casesDetail',
          params: {
            id: row.id
          },
          query: {
            line_id, template_id
          }
        })
      },
      handleDel(row) {
        _this.$confirm({
          title: `确定要删除吗？`,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            const res = await casesDelete({ id: row.id })
            if (_this.$validate(res)) {
              _this.$message.success(`删除成功！`)
              methods.getList()
            }
          }
        })
      },
      async handleChange(value) {
        state.addForm.template_id = undefined
        const res = await api.listTemplate({
          line_id: value,
          state: 1,
          template_type: 3, // 模板所属 1文章 2采访 3案例
          page: 1,
          per_page: 3000
        })
        if (_this.$validate(res)) {
          state.templateList = res.data.template
        } else {
          state.templateList = []
        }
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleCancel() {
        _this.visible = false
        state.addForm = cloneDeep(addFormReset)
        _this.$refs.addFormRef.resetFields()
        _this.$refs.addFormRef.clearValidate()
      },
      handleOk() {
        _this.$refs.addFormRef.validate(valid => {
          if (valid) {
            this.$router.push({
              path: `/casesDetail`,
              query: {
                ...state.addForm
              }
            })
          }
        })
      }
    }

    return {
      lineListLv1,
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods
    }
  }
}
</script>
<style lang="less">
.status {
  &-0 {
    color: #fb8c00;
  }
  &-1 {
    color: #1fb749;
  }
  &-2 {
    color: #ee0974;
  }
}
</style>
